export const momentTime = () => (input, small) => {
  const format = small
    ? "HH:mm on MMM Do (UTC)"
    : "HH:mm on MMMM Do YYYY (UTC)";
  return momentFormat()(input, format);
};

export const momentFormat = () => (input, format) =>
  moment(input * 1000).format(format);
